module.exports = __webpack_public_path__ + "assets/media/evening.76530d7d.mp3";